const invertedMessages = {
  'Viewing unavailable — Classic Experience Campaign':
    'CERTS_CLASSIC_CAMPAIGN_ALERT_TITLE',
  'This certification was launched in the classic experience. Detailed view cannot be displayed, but your campaign data is preserved and available to download.':
    'CERTS_CLASSIC_CAMPAIGN_ALERT_SUBTITLE',
};

export default invertedMessages;
